import React from "react";
import PropTypes from "prop-types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/system/Box";
import StyledTextField from "../StyledTextField/StyledTextField";

export default function AutocompleteTextField({
  label,
  title,
  isLoading,
  searchInput,
  selected,
  params,
  error,
  maxLength,
  placeholder
}) {
  const indicatorSize = "20px";
  return (
    <StyledTextField
      {...params}
      label={label || title}
      error={error}
      size="small"
      placeholder={placeholder}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <Box sx={{
            maxHeight: indicatorSize
          }}
          >
            {isLoading && searchInput.length >= 4 && (
              <CircularProgress color="inherit" size={indicatorSize} />
            )}
            {!isLoading && selected && (
              <CheckCircleIcon sx={{ color: "success.60", fontSize: indicatorSize }} />
            )}
            {!isLoading &&
              searchInput.length > 0 &&
              !selected && (
              <ErrorOutlineIcon
                sx={{ color: "error.60", fontSize: indicatorSize }}
              />
            )}
            {params.InputProps.endAdornment}
          </Box>
        )
      }}
      inputProps={{ ...params.inputProps, ...maxLength && { maxLength: maxLength } }}
    />
  );
}

AutocompleteTextField.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  searchInput: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  params: PropTypes.object.isRequired,
  error: PropTypes.bool,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string
};